export const DEFAULT_CANCELLATION_POLICY = "moderate";
export const MODERATE_REFUND_CUTOFF_MINUTES = 24 * 60;

export const CANCELLATION_POLICY_OPTIONS = [
  {
    value: "flexible",
    label: "Flexible",
    description: "Full refund anytime before the appointment.",
  },
  {
    value: "moderate",
    label: "Moderate",
    description:
      "Full refund only when the cancellation happens at least 24 hours before the appointment.",
  },
  {
    value: "strict",
    label: "Strict",
    description: "No refunds when a customer cancels.",
  },
];

const POLICY_LOOKUP = CANCELLATION_POLICY_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option;
  return acc;
}, {});

export const normalizeCancellationPolicy = (value) => {
  const normalized =
    typeof value === "string" ? value.trim().toLowerCase() : "";
  return POLICY_LOOKUP[normalized]?.value || DEFAULT_CANCELLATION_POLICY;
};

export const getCancellationPolicyOption = (value) => {
  const normalized = normalizeCancellationPolicy(value);
  return POLICY_LOOKUP[normalized] || POLICY_LOOKUP[DEFAULT_CANCELLATION_POLICY];
};

export const evaluateCancellationRefundEligibility = ({
  policy,
  appointmentStartDateTime,
  now = new Date(),
}) => {
  const normalizedPolicy = normalizeCancellationPolicy(policy);
  const startDate =
    appointmentStartDateTime instanceof Date
      ? appointmentStartDateTime
      : new Date(appointmentStartDateTime);
  const validStartDate = !Number.isNaN(startDate.getTime());

  if (!validStartDate) {
    return {
      policy: normalizedPolicy,
      eligible: false,
      message:
        "This appointment is non-refundable under the cancellation terms shown when you booked.",
    };
  }

  const minutesAhead = Math.floor((startDate.getTime() - now.getTime()) / 60000);
  const beforeAppointment = minutesAhead > 0;

  if (normalizedPolicy === "strict") {
    return {
      policy: normalizedPolicy,
      eligible: false,
      message:
        "This appointment is non-refundable under the cancellation terms shown when you booked.",
    };
  }

  if (!beforeAppointment) {
    return {
      policy: normalizedPolicy,
      eligible: false,
      message:
        "This appointment is non-refundable under the cancellation terms shown when you booked.",
    };
  }

  if (
    normalizedPolicy === "moderate" &&
    minutesAhead < MODERATE_REFUND_CUTOFF_MINUTES
  ) {
    return {
      policy: normalizedPolicy,
      eligible: false,
      message:
        "This appointment is non-refundable under the cancellation terms shown when you booked.",
    };
  }

  return {
    policy: normalizedPolicy,
    eligible: true,
    message: "You will receive a full refund.",
  };
};
